import { Component } from '@angular/core';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widget-block-title-description',
  templateUrl: './block-title-description.component.html',
  styleUrls: ['./block-title-description.component.scss'],
})
export class BlockTitleDescriptionComponent extends WidgetBaseComponent {}
